/** Full-page entry to one-time proctored return (matches router path). */
const PROCTORED_ENTRY_RE = /^\/assessment\/proctored\/([^/?#]+)\/?$/;

export function proctoredTokenFromPathname(pathname = window.location.pathname) {
    const m = pathname.match(PROCTORED_ENTRY_RE);
    return m ? m[1] : null;
}

export function isProctoredAssessmentEntryPath(pathname = window.location.pathname) {
    return PROCTORED_ENTRY_RE.test(pathname);
}
